import { useState, useEffect } from "react";
/**
 * useMatchMedia
 * @param query a query like `(min-width: 768px)`
 * @returns a boolean
 */
export const useMatchMedia = (query) => {
    const [matches, setMatches] = useState(() => matchMedia(query).matches);
    useEffect(() => {
        const mediaQueryList = matchMedia(query);
        const onChange = (event) => setMatches(event.matches);
        mediaQueryList.addEventListener("change", onChange);
        return () => mediaQueryList.removeEventListener("change", onChange);
    }, [query]);
    return matches;
};
